import { resolveRuntimeApiBaseUrl, resolveRuntimeApiUrl } from '../utils/runtimeApiSupport';

const requestedBaseUrl = process.env.EXPO_PUBLIC_API_BASE_URL;

export const RUNTIME_API_BASE_URL = resolveRuntimeApiBaseUrl(requestedBaseUrl);

export const RUNTIME_API_CONFIG = {
  baseUrl: RUNTIME_API_BASE_URL,
  enabled: Boolean(requestedBaseUrl?.trim()),
  sameOrigin: RUNTIME_API_BASE_URL === '',
} as const;

export const buildRuntimeApiUrl = (pathOrUrl: string): string =>
  resolveRuntimeApiUrl(RUNTIME_API_BASE_URL, pathOrUrl);
